import FieldStatus from "../../../../fields3/generic/status/status"
import FieldConfig from "../../../../fields3/proto/field-config"
import FieldTaskSystemStatus_ConditionForm from "./render/condition"
import {ConditionType_Excludes, ConditionType_Includes} from "../../../../model2/conditions/condition-types"
import FieldTaskSystemStatus_QuickFilterView from "./render/quick-filter-view"

/** !!!! CREATED FOR conditionForm render, other views are not tested !!!! **/

export default class FieldTaskSystemStatus extends FieldStatus {

    constructor(config:FieldConfig) {
        super(config)


        this.conditionTypes         = [ConditionType_Includes, ConditionType_Excludes]

        this.typeLabel              = "Task System Status"
        this.filterType             = null

        this.noValueOption          = false // system status always set

        this.options                = gd.const.systemStatus.options

        this.canManuallySetValue    = false

        _.assign(this.components, {
            PopoverMenuMore     : null,
        })

        // _.assign(this.renderComponents, {
        //     conditionForm       : FieldTaskSystemStatus_ConditionForm
        // })

        this.renderComponents.conditionForm     = FieldTaskSystemStatus_ConditionForm
        this.renderComponents.quickFilterView   = FieldTaskSystemStatus_QuickFilterView
    }
}
